export default function loadScript(src = undefined) {
    if (!src || $(`script[src="${src}"]`).length) {
        return;
    }

    const element = document.createElement('script');
    element.type = 'text/javascript';
    element.src = src;
    document.getElementsByTagName('body')[0].appendChild(element);
}
